import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Card, Form, Grid, List, Segment, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {required, requiredPassword, requiredEmail} from '../../../../common/components/form/common/fieldValidations';
import {InputField, CheckboxField, DropdownField} from '../../../../common/components/form';
import {TOYOTA_RUC} from '../../../../common/constants/dealer';
import {toLowerCase, toUpperCase} from '../../../../common/util/fieldsNormalization';
import {parseAgenciesValues} from '../../../../common/util/options';
import {parsedDirectoryUsers} from '../../../utils';
import InfoModal from './modal/InfoModal';

class TdeFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'visiblePassword': false,
    };
  }
  
  setCheckBoxValue = (e, {checked, name, id, label}) => {
    const {setUserField} = this.props;
    let value = checked ? 'A' : 'I';

    if (name !== 'status') {
      value = checked ? id : null;
    }
    setUserField(name, value);
    if (name.includes('group')) {
      const nameValue = value ? label : '';
      setUserField(`name${name}`, nameValue);
    }
  };

  setCheckBoxValue2 = (e, {checked, name, id, label}) => {
    const {setUserField} = this.props;
    const {rolesList} = this.props.formValues;
    const newRoleList = [...rolesList];
    if (checked) {
      newRoleList.push({'groupId': id, 'groupName': label});
    } else {
      newRoleList.splice(newRoleList.indexOf((x) => x.groupId === id), 1);
    }
    setUserField('rolesList', newRoleList);
  };

  getRoleCheckStatus = (groupId) => {
    const {rolesList} = this.props.formValues;
    return rolesList?.find((x) => x.groupId === groupId) ? true : false;
  };

  validateField = async(e) => {
    const {value, name} = e.target;

    if (value) {
      await this.props.checkUserInfo({[name]: value});
    }
  };

  userSelection = (e, value) => {
    const {directory} = this.props;
    this.props.setUserFromDirectory(value, directory);
  }

  changeVisibleState = () => {
    const {visiblePassword} = this.state;
    this.setState({'visiblePassword': !visiblePassword});
  }

  renderPolicies = (disableField) => {
    const {policiesList, loadingPermissions, permissionsList, code} = this.props;

    return policiesList.map((policy, idx) => {
      const group = `group${idx + 1}`;
      const groupId = policy.groups[0].id;

      return (
        <List.Item key={idx}>
          <List.Content>
            {/* <Form.Checkbox
              label={policy.name}
              name={group}
              checked={formValues[group] === groupId}
              id={groupId}
              onChange={this.setCheckBoxValue}
              disabled={disableField}
              readOnly={!!code}
            /> */}
            <Form.Checkbox
              label={policy.name}
              name={group}
              checked={this.getRoleCheckStatus(groupId)}
              id={groupId}
              onChange={this.setCheckBoxValue2}
              disabled={disableField}
              readOnly={!!code}
            />
            <InfoModal
              loading={loadingPermissions}
              name={policy.name}
              list={permissionsList}
              id={policy.id}
            />
          </List.Content>
        </List.Item>
      );
    });
  };

  render() {
    const {usernameError, username, formValues, code, isTdeUser,
      agenciesList, directory, loading, loadingAgencies} = this.props;
    const {status, dealer} = formValues;
    const {visiblePassword} = this.state;
    const isTdeUserEditable = username && TOYOTA_RUC.toString() === dealer;
    const disableField = username && status !== 'A';

    return (
      <Card raised fluid>
        <Grid textAlign='left' className='grid-padding-parameter'>
          {username && (
            <Grid.Row>
              <Grid.Column verticalAlign='middle' width={3}>
                <h3>Estado</h3>
              </Grid.Column>
              <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
                <Form.Checkbox
                  name='status'
                  checked={status === 'A'}
                  onChange={this.setCheckBoxValue}
                  toggle
                />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Usuario</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              {username || code ? (
                <Field
                  name='username'
                  required
                  onBlur={this.validateField}
                  component={InputField}
                  className={usernameError ? 'error' : ''}
                  type='text'
                  maxLength={30}
                  validate={required}
                  normalize={toUpperCase}
                  disabled={!!username || isTdeUserEditable || disableField}
                />
              ) : (
                <Field
                  name='username'
                  required
                  component={DropdownField}
                  validate={required}
                  placeholder='Seleccione un usuario'
                  onChange={this.userSelection}
                  loading={loading}
                  search
                  options={parsedDirectoryUsers(directory)}
                />
              )}
              {usernameError && (
                <span className='error-message'>{usernameError}</span>
              )}
            </Grid.Column>
          </Grid.Row>
          {code && (
            <Grid.Row>
              <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
                <h3>Clave</h3>
              </Grid.Column>
              <Grid.Column width={6}>
                <Field
                  name='password'
                  required
                  component={InputField}
                  type={visiblePassword ? 'text' : 'password'}
                  validate={[required, requiredPassword]}
                  action={
                    <Icon
                      name={visiblePassword ? 'eye slash' : 'eye'}
                      onClick={this.changeVisibleState}
                    />
                  }
                />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
            <h3>Nombre de Usuario</h3>
          </Grid.Column>
          <Grid.Column width={6}>
            <Field
              name='name'
              component={InputField}
              required
              type='text'
              normalize={toUpperCase}
              validate={required}
              disabled={disableField}
              readOnly={!!code || isTdeUser || isTdeUserEditable}
            />
          </Grid.Column>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Concesionario</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='dealerName'
                component={InputField}
                normalize={toUpperCase}
                type='text'
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Agencia</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              {isTdeUser || (username && !isTdeUserEditable) ? (
                <Field
                  name='agency'
                  component={DropdownField}
                  required
                  className='agency-selection'
                  options={parseAgenciesValues(agenciesList)}
                  normalize={toUpperCase}
                  disabled={disableField}
                  loading={loadingAgencies}
                  type='text'
                />
              ) : (
                <Field
                  name='agencyName'
                  component={InputField}
                  type='text'
                  readOnly
                />
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Correo electrónico</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='email'
                component={InputField}
                required
                validate={requiredEmail}
                normalize={toLowerCase}
                disabled={disableField}
                readOnly={!!code || isTdeUser || isTdeUserEditable}
                type='email'
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Fecha de creación</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field name='date' component={InputField} required readOnly />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
              <h3>Solicitante</h3>
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                name='modificationUser'
                component={InputField}
                required
                type='text'
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          {!isTdeUser && !isTdeUserEditable && (
            <>
              <Grid.Row>
                <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
                  <h3>Sistema</h3>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    label='TEMS'
                    name='system'
                    component={CheckboxField}
                    disabled={true}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign='left' verticalAlign='middle' width={3}>
                  <h3>Perfiles</h3>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Segment>
                    <List>{this.renderPolicies(disableField)}</List>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </>
          )}
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'formValues': state.userForm.values,
    'loadingAgencies': state.dealer.loadingAgencies,
    'agenciesList': state.dealer.agenciesList,
    'policiesList': state.userForm.policiesList,
    'permissionsList': state.userForm.permissionsList,
    'rolesList': state.userForm.rolesList,
    'loadingPermissions': state.userForm.loadingPermissions,
    'usernameError': state.userForm.usernameError,
    'directory': state.usersList.directory,
    'loadingCheck': state.userForm.loadingCheck,
    'loading': state.usersList.loading,
  };
};

const {checkUserInfo, setUserField, fetchUserByParams, setUserFromDirectory} =
  Actions;

export default connect(mapStateToProps, {
  checkUserInfo,
  setUserField,
  fetchUserByParams,
  setUserFromDirectory,
})(TdeFields);
